<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>出入金统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">支付开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.startDate" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">支付结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.endDate" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">批次号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.batchNo" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">客户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="table" class="full-height display-col">
        <div class="tips">
          <span class="tip-item">国际运费收入总额：{{addThousandSeparator(form.totalInternationalFreight)}}元</span>
          <span class="tip-item">批次收入总额：{{addThousandSeparator(form.totalIncomeFee)}}元</span>
          <span class="tip-item">运费成本总额预估：{{addThousandSeparator(form.totalFreightCost)}}元</span>
          <span class="tip-item">批次毛利总额预估：{{addThousandSeparator(form.totalNetFee)}}元</span>
        </div>
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="payTime" align="center" label="支付日期" width="90">
            <template v-slot="scope">
              {{ scope.row.payTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="userId" align="center" label="客户ID">
          </el-table-column>
          <el-table-column prop="batchNo" align="center" label="批次号" width="130">
          </el-table-column>
          <el-table-column prop="sendTime" align="center" label="发货时间" width="90">
            <template v-slot="scope">
              {{ scope.row.sendTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="route" align="center" label="线路">
            <template v-slot="scope">
              {{scope.row.route === '1' ? "空运": "海运"}}
            </template>
          </el-table-column>
          <el-table-column prop="logisticCompany" align="center" label="物流公司">
          </el-table-column>
          <el-table-column prop="waybillNumber" align="center" label="国际运单号">
          </el-table-column>
          <el-table-column prop="containerBoxesCount" align="center" label="箱数">
          </el-table-column>
          <el-table-column prop="throwWeight" align="center" label="抛重">
          </el-table-column>
          <el-table-column prop="realWeight" align="center" label="实重">
          </el-table-column>
          <el-table-column prop="internationalFreight" align="center" label="国际运费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.internationalFreight)}}
            </template>
          </el-table-column>
          <el-table-column prop="boxFee" align="center" label="箱子费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.boxFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="printFee" align="center" label="打印费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.printFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="otherFee" align="center" label="其他费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.otherFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="incomeFee" align="center" label="收入">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.incomeFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="freightCost" align="center" label="运费成本预估">
            <template v-slot="scope">
              <el-input maxlength="50" @change="trackingNumberChange(scope.row.freightCost, scope.row.batchNo)" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        v-model="scope.row.freightCost"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="total" align="center" label="毛利预估">
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  name:'batchIncome',
  data () {
    return {
      queryInfo: {
        startDate: '',
        endDate: '',
        pageSize: 10,
        pageNum: 1,
        userName:'',
        batchNo:""
      },
      recordList: [],
      total: 0,
      form: {},
    }
  },
  methods: {
    getTime () {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.queryInfo.startDate = year + '-' + month + '-' + '01';
      this.queryInfo.endDate = year + '-' + month + '-' + day;
      this.getrecordList();
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async exportAction () {
      this.$http({
        url: '/financial/exportContainerIncome',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '批次收入统计列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getTool();
    },
    async getrecordList () {
      const { data: res } = await this.$http.get('/financial/queryContainerIncome', { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNum = 1
      this.queryInfo.batchNo = ''
       this.queryInfo.endDate= ''
      this.queryInfo.startDate = ''
      this.queryInfo.userName = ''
    },
    async getTool () {
      const { data: res } = await this.$http.get('/financial/queryContainerIncomeHeader', { params: this.queryInfo });
      this.form = res.data
    },
    async trackingNumberChange(freightCost, containerBatchNo) {
      // const { data: res } = await
      this.$http.post("/financial/updateFreightCost", { containerBatchNo: containerBatchNo, freightCost: freightCost }).then(
          res => {
            if (res.data.code == '200') {
              this.getrecordList();
              this.getTool();
            }else {
              this.$message({
                type: "error",
                message: "无法修改",
              });
            }

          }
      );

    },
  },
  created () {
    this.getTime()
    this.getTool()
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.tips {
  margin: 15px 0;
  text-align: right;
}
.tip-item{
  margin-left: 30px;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
